import React, { FC } from 'react';
import { HStack } from '@chakra-ui/react';

import { useCompanyBankAccounts } from 'common/hooks/useCompanyBankAccounts';
import useFeatureFlagsSwitcher from 'common/hooks/useFeatureFlagsSwitcher';
import BankAccountPicker from 'components/BankAccountPicker';

import { LoadingIntervalSkeleton } from '../LoadingIntervalSkeleton';

type CashflowBankAccountPickerProps = {
  selectedBankAccountId: string | undefined | null;
  onBankAccountChange: (id: string | null | undefined) => void;
};

export const CashflowBankAccountPicker: FC<CashflowBankAccountPickerProps> = ({
  onBankAccountChange,
  selectedBankAccountId,
}) => {
  const { featureFlags } = useFeatureFlagsSwitcher();

  const { bankAccounts, loading } = useCompanyBankAccounts();

  if (!featureFlags.enableCashFlowMultiWallet) {
    return null;
  }

  if (loading) {
    // TODO: check with Design if skeleton or nothing
    // But for now, since we are pre-fetching the data
    // we will not have content-shift
    return (
      <HStack marginBottom="space-16">
        <LoadingIntervalSkeleton />
      </HStack>
    );
  }

  if (!bankAccounts?.length || bankAccounts?.length < 1) {
    return null;
  }

  return (
    <HStack marginBottom="space-16">
      <BankAccountPicker
        onBankAccountChange={onBankAccountChange}
        selectedBankAccountId={selectedBankAccountId || undefined}
        withAllAccountsOption={false}
      />
    </HStack>
  );
};
